<template>
  <ul :class="['d-flex', 'justify-content-between', 'lista', `lista-${cor}`]">
    <li>
      {{ticket}}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ticket',
  props: {
    ticket: {
      required: true,
    },
    cor: {
      type: String,
      default: 'red',
    },
  },
}
</script>

<style>
.lista {
  min-width: 150px;
  list-style: none;
  height: 50px;
}

.lista-red li {
  background-image: linear-gradient(to top, #b30000 0%, #fbb936 100%);
}

.lista-blue li {
  background-image: linear-gradient(to top, #0021b3 0%, #36ddfb 100%);
}

.lista li {
  padding: 5px 3px;
  width: 150px;
  box-shadow: 0 17px 40px 0 rgba(243, 42, 126, 0.35);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  font-size: 36px;
  color: #ffffff;
  line-height: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
